<template>
  <nav class="footer-bar" aria-label="منوی پایین موبایل">
    <button type="button" class="footer-bar-a footer-bar-menu" :class="{'footer-bar-a--active':menuOpen}" :aria-expanded="String(menuOpen)" aria-controls="hz-mobile-menu" aria-haspopup="dialog" @click="toggleMenu">
      <span class="footer-bar-a__icon"><MobileNavIcon name="bi-grid" /></span>
      <span class="footer-bar-span">منو</span>
    </button>

    <router-link to="/user/reports" class="footer-bar-a" active-class="footer-bar-a--active">
      <span class="footer-bar-a__icon"><MobileNavIcon name="bi-file-earmark-bar-graph" /></span>
      <span class="footer-bar-span">گزارشات</span>
    </router-link>

    <router-link
      to="/user/exchange"
      class="footer-bar-a footer-bar-a--exchange"
      active-class="footer-bar-a--active"
      aria-label="تبادل"
    >
      <span class="footer-bar-a__icon">
        <MobileNavIcon name="bi-arrow-down-up" />
      </span>
      <span class="footer-bar-span">تبادل</span>
    </router-link>

    <router-link
      to="/user/withdraws"
      class="footer-bar-a"
      active-class="footer-bar-a--active"
    >
      <span class="footer-bar-a__icon">
        <MobileNavIcon name="bi-cash-stack" />
      </span>
      <span class="footer-bar-span">برداشت</span>
    </router-link>

    <router-link
      to="/user/wallet"
      class="footer-bar-a"
      active-class="footer-bar-a--active"
    >
      <span class="footer-bar-a__icon">
        <MobileNavIcon name="bi-wallet" />
      </span>
      <span class="footer-bar-span">کیف پول</span>
    </router-link>
  </nav>
</template>

<script>
import MobileNavIcon from "./MobileNavIcon.vue";
export default {
  name: "FooterMenu",
  components: {MobileNavIcon},
  data: () => ({menuOpen:false}),
  mounted() { this.menuStateListener = event => { this.menuOpen = Boolean(event.detail); }; window.addEventListener('hz:mobile-menu-state', this.menuStateListener); },
  beforeUnmount() { window.removeEventListener('hz:mobile-menu-state', this.menuStateListener); },
  methods: { toggleMenu() { window.dispatchEvent(new Event('hz:mobile-menu-toggle')); } },
};
</script>

<style scoped>
.footer-bar {
  position: fixed;
  bottom: 0.65rem;
  left: 0.75rem;
  right: 0.75rem;
  z-index: 98;
  background: linear-gradient(180deg, rgba(28, 29, 36, 0.96), rgba(18, 19, 24, 0.98));
  border: 1px solid rgba(239, 177, 0, 0.14);
  border-radius: 24px;
  min-height: 72px;
  padding: 0.4rem 0.6rem calc(0.45rem + env(safe-area-inset-bottom, 0px));
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 0.25rem;
  text-align: center;
  transition: all 0.35s ease;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.24);
  backdrop-filter: blur(14px);
  direction: ltr;
}

.footer-bar-a {
  color: rgba(255, 255, 255, 0.7) !important;
  position: relative;
  text-decoration: none;
  flex: 1;
  min-width: 0;
  min-height: 64px;
  padding: 0.55rem 0.25rem 0.45rem;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  direction: rtl;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.footer-bar-a:active {
  transform: scale(0.95);
}

.footer-bar-a__icon {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.72);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.footer-bar-a__icon i {
  font-size: 1.05rem;
  transition: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  vertical-align: middle;
}

/* Fix Bootstrap Icons bottom padding issue */
.footer-bar-a__icon i::before {
  display: block;
  line-height: 1;
}

/* Exchange button - slightly emphasized with subtle shadow only */
.footer-bar-a--exchange .footer-bar-a__icon {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.82);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

/* Active state - clean and minimal */
.footer-bar-a--active {
  color: var(--bs-gold-light) !important;
}

.footer-bar-a--active .footer-bar-a__icon {
  background: linear-gradient(
    135deg,
    rgba(239, 177, 0, 0.16) 0%,
    rgba(239, 177, 0, 0.08) 100%
  );
  color: var(--bs-gold-light);
  box-shadow: 0 0 0 1px rgba(239, 177, 0, 0.12) inset;
}

/* Exchange active state */
.footer-bar-a--exchange.footer-bar-a--active .footer-bar-a__icon {
  background: linear-gradient(
    135deg,
    rgba(239, 177, 0, 0.20) 0%,
    rgba(239, 177, 0, 0.10) 100%
  );
  box-shadow: 
    0 0 0 1px rgba(239, 177, 0, 0.18) inset,
    0 8px 20px rgba(239, 177, 0, 0.14);
}

.footer-bar-span {
  position: relative;
  z-index: 2;
  display: block;
  font-size: 0.68rem;
  font-weight: 500;
  opacity: 0.9;
  font-family: "Vazirmatn", sans-serif;
  transition: opacity 0.25s ease;
}

.footer-bar-a--active .footer-bar-span {
  opacity: 1;
  font-weight: 600;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .footer-bar {
    min-height: 74px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .footer-bar-a {
    min-height: 66px;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
  }

  .footer-bar-a__icon {
    width: 2.2rem;
    height: 2.2rem;
  }

  .footer-bar-span {
    font-size: 0.66rem;
  }
}

@media (max-width: 420px) {
  .footer-bar {
    left: 0.5rem;
    right: 0.5rem;
    bottom: 0.5rem;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
    gap: 0.15rem;
  }

  .footer-bar-a {
    padding-left: 0.15rem;
    padding-right: 0.15rem;
    gap: 0.3rem;
  }

  .footer-bar-a__icon {
    width: 2.05rem;
    height: 2.05rem;
  }

  .footer-bar-a__icon i {
    font-size: 0.95rem;
  }

  .footer-bar-span {
    font-size: 0.62rem;
  }
}

/* Extra small screens */
@media (max-width: 360px) {
  .footer-bar {
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }

  .footer-bar-a__icon {
    width: 1.9rem;
    height: 1.9rem;
  }

  .footer-bar-span {
    font-size: 0.58rem;
  }
}

/* Remove default focus outline and add custom one */
.footer-bar-a:focus-visible {
  outline: none;
}

.footer-bar-a:focus-visible .footer-bar-a__icon {
  box-shadow: 0 0 0 2px rgba(239, 177, 0, 0.3);
}

/* Smooth transitions for theme changes */
@media (prefers-reduced-motion: reduce) {
  .footer-bar,
  .footer-bar-a,
  .footer-bar-a__icon,
  .footer-bar-span {
    transition: none;
  }
}
</style>


<style scoped>
.footer-bar{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));align-items:center}
.footer-bar-a{width:100%}
.footer-bar .footer-bar-a--exchange{
 background:linear-gradient(145deg,var(--bs-gold-light,#efb100),#d6a000);
 color:#17181d!important;transform:translateY(-10px);min-height:74px;
 border:1px solid rgba(255,220,110,.4);border-radius:20px;
 box-shadow:0 7px 20px rgba(239,177,0,.22);
}
.footer-bar .footer-bar-a--exchange .footer-bar-a__icon{
 background:transparent;color:#17181d;box-shadow:none;
}
.footer-bar .footer-bar-a--exchange .footer-bar-a__icon i{font-size:1.35rem}
.footer-bar .footer-bar-a--exchange .footer-bar-span{font-weight:800;opacity:1}
.footer-bar .footer-bar-a--exchange:active{transform:translateY(-10px) scale(.96)}
.footer-bar .footer-bar-a--exchange.footer-bar-a--active{box-shadow:0 0 0 2px #ffe6a0,0 7px 20px rgba(239,177,0,.22)}
.footer-bar .footer-bar-span{font-size:11px;white-space:nowrap}
.footer-bar-a:focus-visible{outline:2px solid #ffe6a0;outline-offset:2px}
@media(max-width:360px){.footer-bar .footer-bar-span{font-size:10px}.footer-bar .footer-bar-a--exchange{border-radius:17px}}
</style>

<style scoped>
@media(max-width:991.98px){
 .footer-bar{min-height:62px;border-radius:20px;padding:4px 5px calc(4px + env(safe-area-inset-bottom,0px));gap:4px}
 .footer-bar .footer-bar-a{min-height:52px;padding:4px 2px;gap:3px;border-radius:14px}
 .footer-bar .footer-bar-a__icon{width:27px;height:27px;border-radius:9px}
 .footer-bar .footer-bar-a__icon{font-size:15px}
 .footer-bar .footer-bar-span{font-size:10px;font-weight:500}
 .footer-bar .footer-bar-a--exchange{width:54px;max-width:100%;justify-self:center;min-height:54px;transform:translateY(-3px);box-shadow:0 3px 10px #efb10018;border-radius:15px}
 .footer-bar .footer-bar-a--exchange .footer-bar-a__icon{font-size:17px}
 .footer-bar .footer-bar-a--exchange .footer-bar-span{font-weight:600}
 .footer-bar .footer-bar-a--exchange:active{transform:translateY(-3px) scale(.97)}
 .footer-bar .footer-bar-a--exchange.footer-bar-a--active{box-shadow:0 0 0 1px #ffe6a0,0 3px 10px #efb10018}
 .footer-bar-menu{border:0;background:transparent;font:inherit;cursor:pointer}
}
</style>
